import React, { useContext, useEffect, useState } from 'react';
import { getAuth, signInWithEmailAndPassword, signOut as _signOut } from "firebase/auth";
import AsyncStorage from '@react-native-async-storage/async-storage';
import {  getLexomeUser } from '../api';

type SavedUser = any;
type LexomeUser = any;

const auth = getAuth();

const stubFn = () => null as any;

export const UserContext = React.createContext<{
  user?: SavedUser;
  setUser: (profile: LexomeUser) => void;
  signInAsGuest: (name: string) => void;
  signInWithEmail: (params: {
    email: string;
    password: string;
  }) => Promise<any>;
  signOut: () => Promise<void>;
}>({
  setUser: () => {},
  signOut: async () => {},
  signInAsGuest: () => {},
  signInWithEmail: stubFn,
}); 

const ANONYMOUS_USER_ID = '2';
const ANONYMOUS_AUTH_ID = '076c4210-d2fd-43a4-bafc-9a5a67bd794f';

export function UserProvider({ children }: { children: JSX.Element }): JSX.Element {
  // const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useState<SavedUser>();

  useEffect(() => {
    const fn = async () => {
      const serializedUser = await AsyncStorage.getItem('user'); 
      if (serializedUser) {
        setUser(JSON.parse(serializedUser))
      }
    }

    fn();
  }, [])

  const clearUser = (): void => {
    setUser(undefined);
    void AsyncStorage.removeItem('user');
  };

  const handleSetUser = (_user: SavedUser): void => {
    const user = {
      ..._user,
      isAdmin: _user.auth_id !== ANONYMOUS_AUTH_ID
    };
    setUser(user);
    void AsyncStorage.setItem('user', JSON.stringify(user));
  };

  const signOut = async (): Promise<void> => {
    clearUser();
    _signOut(auth);
  };

  const signInWithEmail = async ({
    email,
    password
  }: {
    email: string,
    password: string
  }) => {
    try {
      const _authUser = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const authUser = _authUser.user;
      const user = await getLexomeUser({
        authId: authUser.uid
      }) as any;
      const userData = {
        first_name: user.first_name,
        last_name: user.last_name,
        id: user.id,
        auth_id: authUser.uid
      };
      handleSetUser(userData);
    } catch (e) {
      return {
        error: 'sign in failed'
      }
      console.log('sign in failed', e);
    }
  }

  const signInAsGuest = (name?: string) => {
    handleSetUser({
      first_name: name || 'Anonymous',
      last_name: '',
      auth_id: ANONYMOUS_AUTH_ID,
      id: ANONYMOUS_USER_ID,
    })
  }

  return (
    <UserContext.Provider value={{
      user,
      setUser: handleSetUser,
      signOut,
      signInAsGuest,
      signInWithEmail,
    }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => {
  return useContext(UserContext);
}
